import React from 'react';
import { Shield, BookOpen, Layers, Search, Brain, Lock, Map } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 lg:py-32 bg-navy text-cream relative overflow-hidden" data-id="element-172">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#c9a96e 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-173"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-174">
        {/* The Unique Mechanism */}
        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-175">
          <div className="inline-flex items-center justify-center p-3 bg-gold/10 rounded-full mb-6" data-id="element-176">
            <Shield className="text-gold w-8 h-8" data-id="element-177" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-178">
            El Protocolo 3-2-1
          </h2>
          <p className="text-xl text-cream-dark mb-6 leading-relaxed" data-id="element-179">
            Un sistema de ingeniería de flujo de caja para gente real.{' '}
            <strong className="text-gold font-semibold" data-id="element-180">
              No es ahorro, es segregación física de capital.
            </strong>
          </p>
          <p className="text-lg text-navy-light p-6 md:p-8 rounded-2xl border border-white/10 text-left leading-relaxed bg-[#FFFFFF]" data-id="element-181">
            A diferencia de los planes de ahorro aburridos, el Protocolo 3-2-1
            crea compartimentos estancos que "extraen" liquidez de gastos
            invisibles y la blindan tras una barrera psicológica y bancaria. Es
            la diferencia entre tener un balde de agua y tener un sistema de
            riego automático que guarda agua para la sequía sin que te des
            cuenta.
          </p>
        </div>

        {/* What You Get */}
        <div className="max-w-5xl mx-auto" data-id="element-182">
          <h3 className="font-heading text-3xl font-bold text-center mb-12 text-white" data-id="element-183">
            Lo que obtienes hoy
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
            {/* Item 1 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-185">
              <BookOpen className="text-gold w-10 h-10 mb-6" data-id="element-186" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-187">
                El Manual "El Arca de Efectivo"
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-188">
                PDF de implementación inmediata. Todo el sistema explicado sin
                jerga financiera, listo para aplicar.
              </p>
            </div>

            {/* Item 2 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-189">
              <Layers className="text-gold w-10 h-10 mb-6" data-id="element-190" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-191">
                El Protocolo 3-2-1
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-192">
                La estructura exacta de cuentas para separar tu flujo diario, tu
                fondo de emergencia y tu paz mental.
              </p>
            </div>

            {/* Item 3 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-193">
              <Search className="text-gold w-10 h-10 mb-6" data-id="element-194" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-195">
                Escaneo de Activos Invisibles
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-196">
                Cómo encontrar tus primeros $250 en 48 horas sin pedir prestado
                ni endeudarte más.
              </p>
            </div>

            {/* Item 4 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-197">
              <Brain className="text-gold w-10 h-10 mb-6" data-id="element-198" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-199">
                Técnica de Dopamina Inversa
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-200">
                Hackea tu cerebro para convertir el hábito del ahorro en un
                vicio positivo y gratificante.
              </p>
            </div>

            {/* Item 5 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-201">
              <Lock className="text-gold w-10 h-10 mb-6" data-id="element-202" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-203">
                Guía de Blindaje Anti-Sabotaje
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-204">
                Estrategias psicológicas y técnicas para evitar que tú mismo te
                robes el fondo de emergencia.
              </p>
            </div>

            {/* Item 6 */}
            <div className="bg-navy-light/50 border border-gold/20 p-8 rounded-2xl hover:bg-navy-light transition-colors duration-300" data-id="element-205">
              <Map className="text-gold w-10 h-10 mb-6" data-id="element-206" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-207">
                Hoja de Ruta: Primeros $1,000
              </h4>
              <p className="text-cream-dark text-sm leading-relaxed" data-id="element-208">
                El paso a paso diario, detallado para los primeros 30 días. Cero
                conjeturas, pura ejecución.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}